import axios, { AxiosError } from "axios";
import config from "../../../config";
import {
  MarketplaceAppItem,
  DeploymentType,
  MarketplaceAppProvisionApiResponse,
  MarketplaceCategory,
  ApiError,
} from "../../../marketplace/types";
import getFetch from "../../getFetch";
import { ContactFormData } from "../../../marketplace/contact-us/types";

const Marketplace = {
  fetchMarketplaceApps: async (): Promise<MarketplaceAppItem[]> => {
    const response = await axios.get<MarketplaceAppItem[]>(
      `${config.api_url}/marketplace/v1/apps`,
    );
    return response.data;
  },

  fetchDeploymentTypes: async (appId: number): Promise<DeploymentType[]> => {
    const response = await axios.get<DeploymentType[]>(
      `${config.api_url}/marketplace/v1/apps/${appId}/deployment-types`,
    );
    return response.data;
  },

  fetchMarketplaceCategories: async (): Promise<MarketplaceCategory[]> => {
    const response = await axios.get<MarketplaceCategory[]>(
      `${config.api_url}/marketplace/v1/categories`,
    );
    return response.data;
  },

  provisionMarketplaceApp: async (
    projectId: string,
    regionTag: string,
    appId: number,
    deploymentTypeId: number,
    data: { [key: string]: any },
  ): Promise<MarketplaceAppProvisionApiResponse> => {
    try {
      const response = await axios.post<MarketplaceAppProvisionApiResponse>(
        `${config.api_url}/marketplace/v1/provisioned-apps/${regionTag}/${projectId}?save_credentials=1`,
        { data, appId, deploymentTypeId },
      );

      if (response.status === 200) {
        if (response.data.status === "error") {
          return {
            status: "error",
            message: response.data.message,
            errors: response.data.errors,
          };
        }
        return { status: "success" };
      } else {
        return {
          status: "error",
          message: "Unexpected success status code",
        };
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        console.error(
          "Error provisioning marketplace app:",
          axiosError.response.data,
        );
        const errorData = axiosError.response.data as ApiError;
        return {
          status: "error",
          message: errorData.error?.message || "An unexpected error occurred",
        };
      } else {
        console.error("Unexpected error:", axiosError);
        return {
          status: "error",
          message: "An unexpected error occurred",
        };
      }
    }
  },

  deleteProvisionedApp: function (
    projectId: string,
    regionTag: string,
    provisionedAppId: number,
    stackName?: string,
  ) {
    const url = `${config.api_url}/marketplace/v1/provisioned-apps/${regionTag}/${projectId}/${provisionedAppId}${
      stackName ? `?stack_name=${encodeURIComponent(stackName)}` : ""
    }`;

    return getFetch({
      url,
      type: "delete",
    });
  },

  contactUs: function (appId: number, objectToSend: ContactFormData) {
    return getFetch({
      url: `${config.api_url}/marketplace/v1/apps/${appId}/contact-us`,
      type: "post",
      params: objectToSend,
    });
  },
};

export default Marketplace;
